import { type FC } from "react";

import { useIntl } from "react-intl";

import questionIconSvg from "@app-assets/svg/question-icon.svg";

import { MailToLink } from "../../../../shared/components";
import { LENSSTUDIO_SUPPORT_EMAIL } from "../../../util";

import {
    QuestionIcon,
    UnknownErrorsContainer,
    UnknownErrorsMessageContent,
    UnknownErrorsMessageTitle,
} from "./UnknownErrors.styles";
import { UnknownErrorsMessage1, UnknownErrorsMessage3, UnknownErrorsOccurred, messages } from "./messages.generated";

export const UnknownErrors: FC = () => {
    const intl = useIntl();
    return (
        <UnknownErrorsContainer>
            <QuestionIcon src={questionIconSvg} />
            <UnknownErrorsMessageTitle>
                <UnknownErrorsOccurred />
            </UnknownErrorsMessageTitle>
            <UnknownErrorsMessageContent>
                <UnknownErrorsMessage1 />
                <MailToLink
                    mailTo={LENSSTUDIO_SUPPORT_EMAIL}
                    subject={intl.formatMessage(messages.emailSubject)}
                    displayText={intl.formatMessage(messages.unknownErrorsMessage2)}
                />
                <UnknownErrorsMessage3 />
            </UnknownErrorsMessageContent>
        </UnknownErrorsContainer>
    );
};
